import React from 'react';

export type TTableFilters = {
  email?: string[];
  phone?: string[];
  identificationNumber?: string[];
  denyType?: string[];
  status?: string[];
  initiatedByFullName?: string[];
  createdAt?: string[];
  updatedAt?: string[];
};

export type TTableSorter = {
  field?: string;
  order?: 'ascend' | 'descend';
};

export type TTablePagination = {
  current?: number;
  pageSize?: number;
};

export type TTableFilterPayloadValue = string | number | boolean;

export type TTableFilterPayload = Record<string, TTableFilterPayloadValue>;

export interface SearchParams {
  search?: string;
  page?: number;
  size?: number;
}

export type TSearchDataTableValues = {
  search: string;
};

export type TColum = {
  key: string;
  id: string;
  isHidden?: boolean;
  identificationNumber?: string;
  createdAt: string;
  financialServices?: boolean;
  cardAccess?: {
    selected?: boolean;
  };
  businessRelationship?: boolean;
  status: string;
  updatedAt: string;
  initiatedByFullName?: string;
  applicationDocumentId?: string;
  earchiveLink?: string;
};

export type TSubmitRecord = TColum & {
  email?: string;
  phone?: string;
  creditBureauData?: {
    selected?: boolean;
  };
  denyType?: string;
  denyReason?: string;
};

export type TSubmitColumnType = {
  title: string | React.ReactNode;
  dataIndex: string;
  key: string;
  render?: (text: unknown, record: TSubmitRecord) => React.ReactNode;
  sorter?: (a: TSubmitRecord, b: TSubmitRecord) => number;
  showSorterTooltip?: boolean | { title?: string };
  filterDropdown?: TFilterDropdown;
  onFilter?: (value: number | string, record: TSubmitRecord) => boolean;
  onCell?: (record: TSubmitRecord, rowIndex?: number) => PersonalDataCellConfig | undefined;
  width?: number;
  align?: 'left' | 'center' | 'right';
};

export type TRevokeRecord = TColum & {
  otherReason?: string;
};

export interface FilterDropdownProps {
  setSelectedKeys: (keys: string[]) => void;
  selectedKeys: string[];
  confirm: () => void;
}

export type TFilterDropdown = (props: FilterDropdownProps) => React.ReactNode;

export interface PersonalDataCellConfig {
  style?: React.CSSProperties;
}

export type TPersonalDataMuiColumn<TRecord> = {
  title: string | React.ReactNode;
  dataIndex: string;
  key: string;
  render?: (text: unknown, record: TRecord) => React.ReactNode;
  sorter?: (a: TRecord, b: TRecord) => number;
  filterDropdown?: TFilterDropdown;
  onCell?: (record: TRecord, rowIndex?: number) => PersonalDataCellConfig | undefined;
  width?: number;
  align?: 'left' | 'center' | 'right';
};

export type TRevokeColumnType = {
  title: string | React.ReactNode;
  dataIndex: string;
  key: string;
  render?: (text: unknown, record: TRevokeRecord) => React.ReactNode;
  sorter?: (a: TRevokeRecord, b: TRevokeRecord) => number;
  showSorterTooltip?: boolean | { title?: string };
  filterDropdown?: TFilterDropdown;
  onFilter?: (value: number | string, record: TRevokeRecord) => boolean;
  onCell?: (record: TRevokeRecord, rowIndex?: number) => PersonalDataCellConfig | undefined;
  width?: number;
  align?: 'left' | 'center' | 'right';
};

/* eslint-disable no-unused-vars */
export type TOptionValue = string | number;

export interface IOption<V extends TOptionValue, L = V> {
  label: L;
  value: V;
}

export type TSelectorFn<T, V extends TOptionValue> = (item: T) => V;

export type TFormatFn<V extends TOptionValue, L> = (val: V) => L;

export enum SubmitApplicationStatus {
  SENT = 'SENT',
  VERIFIED = 'VERIFIED',
  EXPIRED = 'EXPIRED',
  DENIED = 'DENIED',
  ACCEPTED = 'ACCEPTED',
}

export enum RevokeApplicationStatus {
  NEW = 'NEW',
  VERIFIED = 'VERIFIED',
  PENDING = 'PENDING',
  EXPIRED = 'EXPIRED',
  COMPLETED = 'COMPLETED',
}

export type TApplicationStatus = SubmitApplicationStatus | RevokeApplicationStatus;

export type TDocumentType = 'submit' | 'revoke';

export interface ComplexServiceCheckboxValue {
  clientType?: 'INDIVIDUAL' | 'REPRESENTATIVE' | string;
  selected?: boolean;
  counterpartyName?: string;
  counterpartyCode?: string;
}

export type TStatusOwner = 'submit' | 'revoke';

export interface IStatusConfigItem {
  text: string;
  tooltip: string | null;
}

export type TSortFieldMap = Record<string, string>;
